@if (open) {
  <div class="modal-backdrop" role="presentation">
    <section class="modal-panel internal-desc-panel" role="dialog" aria-modal="true" [attr.aria-label]="title">
      <header class="modal-header">
        <h2>{{ title }}</h2>
        <button type="button" class="icon-close" (click)="close()" aria-label="Close">x</button>
      </header>

      <div class="internal-desc-body">
        <nav class="internal-desc-menu">
          @for (category of categories; track category.key) {
            <button
              type="button"
              class="internal-desc-menu-item"
              [class.active]="activeCategoryKey === category.key"
              [class.has-value]="categoryHasValue(category)"
              [class.full-width]="category.fullWidth"
              (click)="selectCategory(category)">
              {{ category.label }}
            </button>
          }
        </nav>

        <div class="internal-desc-content">
          <h3 class="internal-desc-title">{{ activeCategory.label }}</h3>
          @if (activeCategory.isSummary) {
            <section class="internal-desc-finish">
              <label>
                <span>No of Bedrooms</span>
                <input type="number" min="0" [ngModel]="finishItem.noOfBedrooms" (ngModelChange)="updateFinishField('noOfBedrooms', $event)" [ngModelOptions]="{ standalone: true }" />
              </label>
              <label>
                <span>No of Bathrooms</span>
                <input type="number" min="0" [ngModel]="finishItem.noOfBathrooms" (ngModelChange)="updateFinishField('noOfBathrooms', $event)" [ngModelOptions]="{ standalone: true }" />
              </label>
              <label>
                <span>Number of Living Areas</span>
                <input type="number" min="0" [ngModel]="finishItem.numberOfLivingAreas" (ngModelChange)="updateFinishField('numberOfLivingAreas', $event)" [ngModelOptions]="{ standalone: true }" />
              </label>
              <label>
                <span>Accommodation Description</span>
                <textarea rows="5" [ngModel]="finishItem.accommodationDescription" (ngModelChange)="updateFinishField('accommodationDescription', $event)" [ngModelOptions]="{ standalone: true }"></textarea>
              </label>
              <label>
                <span>Additional Features</span>
                <textarea rows="5" [ngModel]="finishItem.additionalFeatures" (ngModelChange)="updateFinishField('additionalFeatures', $event)" [ngModelOptions]="{ standalone: true }"></textarea>
              </label>
              <label>
                <span>Chattels</span>
                <textarea rows="5" [ngModel]="finishItem.chattels" (ngModelChange)="updateFinishField('chattels', $event)" [ngModelOptions]="{ standalone: true }"></textarea>
              </label>
              <label>
                <span>No of Undercover Car Spaces</span>
                <input type="number" min="0" [ngModel]="finishItem.noOfUndercoverCarSpaces" (ngModelChange)="updateFinishField('noOfUndercoverCarSpaces', $event)" [ngModelOptions]="{ standalone: true }" />
              </label>
              <label>
                <span>Car Accommodation</span>
                <input type="text" [ngModel]="finishItem.carAccommodation" (ngModelChange)="updateFinishField('carAccommodation', $event)" [ngModelOptions]="{ standalone: true }" />
              </label>
              <button type="button" class="btn primary finish-copy-button" (click)="copyToImprovementsAndClose()">Copy to improvements and close</button>
              <p class="internal-desc-finish-note"><strong>Note: </strong>This will overwrite the above fields in the valuation report entry screen with the data above.</p>
            </section>
          } @else {
            @for (section of visibleSections(activeCategory); track section.fieldGroup) {
              <ng-container *ngTemplateOutlet="sectionTpl; context: { section: section }" />
            }

            <ng-container *ngTemplateOutlet="sectionTpl; context: { section: additionalFeaturesSection }" />
          }
        </div>
      </div>
    </section>
  </div>
}

<ng-template #sectionTpl let-section="section">
  <section class="internal-desc-section">
    <div class="internal-desc-section-label">{{ section.label }}</div>
    @if (section.mode === 'text') {
      <textarea
        class="internal-desc-other"
        rows="3"
        placeholder="Describe other..."
        [ngModel]="selections[section.fieldGroup]"
        (ngModelChange)="updateTextField(section, $event)"
        [ngModelOptions]="{ standalone: true }"></textarea>
    } @else {
      <div class="internal-desc-option-grid">
        @for (option of optionsFor(section); track option.name) {
          <button
            type="button"
            class="internal-desc-option"
            [class.selected]="isSelected(section, option)"
            (click)="toggleOption(section, option)">
            {{ option.name }}
          </button>
        }
      </div>
      @if (showOtherText(section)) {
        <textarea
          class="internal-desc-other"
          rows="2"
          placeholder="Describe other..."
          [ngModel]="otherText[section.fieldGroup]"
          (ngModelChange)="updateOtherText(section, $event)"
          [ngModelOptions]="{ standalone: true }"></textarea>
      }
    }
  </section>
</ng-template>
